/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { useAuth } from "@/modules/auth";
import { useProfessionalsWithRole } from "@/hooks/useProfessionalsWithRole";
import { ReactSelect, ReactSelectProps } from "../ReactSelect";

type ProfessionalWithRolesSelectProps = ReactSelectProps & {
	roles: string | string[];
	professionalId?: string | number;
};

export function ProfessionalWithRolesSelect({
	roles,
	professionalId,
	...rest
}: ProfessionalWithRolesSelectProps) {
	const [options, setOptions] = useState<ReactSelectOption[]>([]);
	const { professionals } = useProfessionalsWithRole();
	const { currentAuth } = useAuth();

	const loggedUser = options.find((option) => option.value === currentAuth?.user?.id);
	const responsibleProfessional = professionalId
		? options.find((option) => String(option.value) === String(professionalId))
		: loggedUser;

	function getOptions() {
		const filteredProfessionals = professionals?.filter(
			(professional) =>
				professional.profileName?.length && roles.includes(professional.profileName)
		);

		if (filteredProfessionals?.length) {
			setOptions(
				filteredProfessionals.map((professional) => ({
					value: professional.id,
					label: professional.name,
				}))
			);
		}
	}

	useEffect(() => {
		getOptions();
	}, [professionals]);

	return <ReactSelect options={options} value={responsibleProfessional} {...rest} />;
}
